import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

//components
import ToastElement from "../../../Components/UiComponents/ToastElement";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";

//services
import { getCustomerFields } from '../../../Services/fieldsServices';
import InputTextElement from "../../../Components/UiComponents/InputTextElement";
import { updateAddress } from "../../../Services/addressService";
import { RadioButton } from "primereact/radiobutton";
import AutoCompleteElement from "../../../Components/UiComponents/AutoCompleteElement";
import { api } from "../../../Apis/interceptor";


export default function EditAddress(props) {

    const [visible, setVisible] = useState(false);
    const [location, setLocation] = useState([]);
    const [address1, setAddress1] = useState([]);
    const [address2, setAddress2] = useState([]);
    const [officeNumber, setOfficeNumber] = useState([]);
    const [telephoneNumber, setTelephoneNumber] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [postcode, setPostcode] = useState([]);
    const [country, setCountry] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedAssociatedClient, setSelectedAssociatedClient] = useState(null);
    const [associatedDataClient, setAssociatedDataClient] = useState([])
    const [cliRes, setCliRes] = useState([])
    const [editData, setEditData] = useState({})
    const toastRef = useRef();

    useEffect(() => {

        if (props?.fieldDetail) {
            let filterDetails = props?.fieldDetail.filter(item => item.module_name === 'Common Fields')

            let field = filterDetails[0]?.sub_modules[0]?.fields
            if (field) {
                let location = field.filter(item => item.field_name === 'Location Name')
                let address1 = field.filter(item => item.field_name === 'Address Line 1')
                let address2 = field.filter(item => item.field_name === 'Address Line 2')
                let officeNumber = field.filter(item => item.field_name === 'Office Number')
                let telephoneNumber = field.filter(item => item.field_name === 'Telephone Number')
                let city = field.filter(item => item.field_name === 'City')
                let state = field.filter(item => item.field_name === 'State/County')
                let postcode = field.filter(item => item.field_name === 'Postcode')
                let country = field.filter(item => item.field_name === 'Country')


                setLocation(location)
                setAddress1(address1)
                setAddress2(address2)
                setOfficeNumber(officeNumber)
                setTelephoneNumber(telephoneNumber)
                setCity(city)
                setState(state)
                setPostcode(postcode)
                setCountry(country)
            }
        }

    }, [props?.fieldDetail]);

    useEffect(() => {

        if (props?.addressDetail?.associated === "Client") {

            setSelectedAssociatedClient(props?.addressDetail?.associated_name || '');
        } else {

            setSelectedAssociatedClient('');
        }
    }, [props?.addressDetail]);


    useEffect(() => {
        reset();
        // To auto populate form
        if (props?.addressDetail && props?.visible) {
            const edit = _.cloneDeep(props?.addressDetail);


            setEditData(edit);
        }
    }, [props?.addressDetail]);

    useEffect(() => {
        getCustomer()
    }, [props?.customerId]);

    const getCustomer = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (props?.customerId !== null) {
                const response = await getCustomerFields(props?.customerId);
                if (response && response.data) {
                    let data = response?.data?.reference_data
                    let state = data?.filter(item => item.display_name === 'Country List')
                    setCountries(state[0].option_choice)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    // Function to create new prompt
    const onSubmit = async (promptData) => {
        let data = props?.addressDetail;
        data.customer_id = props?.customerId;
        data.address_name = promptData.address_name
        // data.associated_name =promptData.associated_name
        data.building_name = promptData.building_name
        data.address_line_two = promptData.address_line_two
        data.city = promptData.city
        data.office_addr_contact = promptData.office_addr_contact
        data.postcode = promptData.postcode
        data.state = promptData.state
        data.telephone_number = promptData.telephone_number
        data.country = promptData?.country?.label
        data.associated = props?.addressDetail?.associated
        if (props?.addressDetail?.associated === "Client") {
            if (cliRes.length > 0) {
                data.associated_name = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?.client_name
                data.associated_id = cliRes?.find((item) => item.client_name === selectedAssociatedClient)?._id
            }
            else {
                data.associated_name = props?.addressDetail?.associated_name
                data.associated_id = props?.addressDetail?.associated_id

            }
        }

        try {
            const response = await updateAddress(props?.addressDetail?._id, data);

            if (response?.status === 200 && response?.data?.message === "Address Name Already Exist") {
                toastRef.current.showToast({
                    type: "error",
                    message: `${response?.data?.message}`,
                });
            } else if (response?.status === 200 && response?.data?.message === "Address Info Updated Successfully") {
                closePopup();
                setSelectedAssociatedClient(null)
                toastRef.current.showToast({
                    type: "success",
                    message: `${response?.data?.message}`,
                });
            }
            else {
                toastRef.current.showToast({
                    type: "error",
                    message: response?.data.message,
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const closePopup = () => {
        reset();
        setVisible(false);
        props.onHide();
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Update" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }


    const handleGetClient = async () => {
        try {
            if (props.customerId === null && props.branch === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const CliResponse = await api.get("/api/v1/getClients", {
                params: { cust_id: props?.customerId, searchVal: selectedAssociatedClient, branch_id: props?.branch?.branch_id },
            });
            setCliRes(CliResponse.data?.client)
            const AssociatedDisplayNames = CliResponse.data?.client?.map(
                (cli) => cli.client_name
            );

            setAssociatedDataClient(AssociatedDisplayNames);
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };


    return (
        <div>
            <ToastElement ref={toastRef} />
            <Dialog
                header={_.find(props?.addressSections, { section_name: "Edit Address" })?.display_name}
                visible={props.visible}
                position={props.position}
                onHide={() => {
                    closePopup();
                }}
                footer={renderFooter()}
                className="width-40vw"
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {
                            _.find(props.commonFields, { field_name: "Location Name" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {location[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_name"
                                        control={control}
                                        defaultValue={editData?.address_name}
                                        rules={{
                                            required: "Location Name is required",
                                            minLength: {
                                                value: 2,
                                                message: "Location Name must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "Location Name cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "Location Name contains invalid characters"
                                            }
                                        }}

                                        render={({ field }) => (
                                            <InputTextElement id="address_name" {...field} />
                                        )}
                                    />
                                    {errors?.address_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.address_name.message}
                                        </small>
                                    )}
                                </div>

                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Address Line 1" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {address1[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="building_name"
                                        control={control}
                                        rules={{

                                            minLength: {
                                                value: 2,
                                                message: "Address 1 must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "Address 1 cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "Address 1 contains invalid characters"
                                            }
                                        }}
                                        defaultValue={editData?.building_name}
                                        render={({ field }) => (
                                            <InputTextElement id="building_name" {...field} />
                                        )}
                                    />
                                    {errors?.building_name && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.building_name.message}
                                        </small>
                                    )}

                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Address Line 2" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0" >
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {address2[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="address_line_two"
                                        control={control}
                                        rules={{

                                            minLength: {
                                                value: 2,
                                                message: "Address 2 must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "Address 2 cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "Address 2 contains invalid characters"
                                            }
                                        }}
                                        defaultValue={editData?.address_line_two}
                                        render={({ field }) => (
                                            <InputTextElement id="address_line_two" {...field} />
                                        )}
                                    />
                                    {errors?.address_line_two && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.address_line_two.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Associated to" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {_.find(props.commonFields, { field_name: "Associated to" })?.display_name}
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="associated"
                                        control={control}
                                        defaultValue={editData?.associated === "Client" && true}
                                        rules={{ required: "Associated to is required" }}
                                        render={({ field }) => (
                                            <>
                                                <RadioButton
                                                    inputId="client"
                                                    value={true}
                                                    onChange={(e) => {
                                                        field.onChange(e.value);
                                                    }}
                                                    checked={field.value === true}
                                                />
                                                <label
                                                    htmlFor="client"
                                                    className="p-radiobutton-label"
                                                >
                                                    {_.find(props.fieldDetail, { module_name: "Clients" })?.display_name}
                                                </label>
                                                {/* <RadioButton
                                                    inputId="organisation"
                                                    value={false}
                                                    onChange={(e) => {
                                                        field.onChange(e.value);
                                                        setAssociated(e.value);
                                                    }}
                                                    checked={field.value === false}
                                                    className="ml-20"
                                                />
                                                <label
                                                    htmlFor="organisation"
                                                    className="p-radiobutton-label"
                                                >
                                                    Organisation
                                                </label> */}
                                            </>
                                            // <RadioElement
                                            //     options={[
                                            //         { key: "true", name: "StakeHolders" },
                                            //         { key: "false", name: "Organisation" },
                                            //     ]}
                                            //     onChangeRadio={(value) => {
                                            //         field.onChange(value === 'true');
                                            //         setAssociated(value === 'true');
                                            //         // setGlobalOpportunityData((prevData) => ({
                                            //         //     ...prevData,
                                            //         //     opportunity: {
                                            //         //         ...prevData.opportunity,
                                            //         //         existing_framework: value === 'true',
                                            //         //     }
                                            //         // }));
                                            //         // handleInputChange(value === 'true');
                                            //     }}
                                            //     value={field.value ? 'true' : 'false'}
                                            //     className="radio-group-class" // Add any additional classes if necessary
                                            //     disabled={false} // Adjust the disabled prop as needed
                                            // />
                                        )}
                                    />
                                    {errors?.associated && (
                                        <div>
                                            <small className="text-red-500 ml-1 color_red_new">
                                                {errors?.associated.message}
                                            </small>
                                        </div>
                                    )}

                                </div>

                            </div>
                        }
                        {(editData?.associated && editData?.associated === "Client" &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        Client:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="associated_name"
                                        control={control}
                                        rules={{ required: "Client Name is required" }}
                                        defaultValue={selectedAssociatedClient}
                                        render={({ field }) => (
                                            <AutoCompleteElement
                                                {...field}
                                                id="cli"
                                                value={selectedAssociatedClient}
                                                onChangeValue={(e) => {
                                                    field.onChange(e.value);
                                                    setSelectedAssociatedClient(e.value);
                                                }}
                                                placeholder="Search Client Name"
                                                suggestions={associatedDataClient}
                                                autocomplete="off"
                                                completeMethod={handleGetClient}
                                                className="w-full"
                                                emptyMessage="No results found"
                                                isPurposeScore={true}
                                            />
                                        )}
                                    />
                                    {errors.associated_name && (
                                        <small className="text-red-500 ml-1 color_red_new">{errors.associated_name.message}</small>
                                    )}
                                </div>
                            </div>
                        )}
                        {
                            _.find(props.commonFields, { field_name: "Office Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {officeNumber[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="office_addr_contact"
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Office number is not valid"
                                            }
                                        }}
                                        defaultValue={editData?.office_addr_contact}
                                        render={({ field }) => (
                                            <InputTextElement id="office_addr_contact" {...field} />
                                        )}
                                    />
                                    {errors?.office_addr_contact && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.office_addr_contact.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Telephone Number" })?.field_status &&
                            <div className="form-group row align-items-center mt-0 mb-0">
                                <div className="col-md-4 text-left pl-0">
                                    <label className="form-label text-left">
                                        {telephoneNumber[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="telephone_number"
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value: /^[+]?\d{1,4}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,9}$/,
                                                message: "Telephone number is not valid"
                                            }
                                        }}
                                        defaultValue={editData?.telephone_number}
                                        render={({ field }) => (
                                            <InputTextElement id="telephone_number" {...field} />
                                        )}
                                    />
                                    {errors?.telephone_number && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.telephone_number.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "City" })?.field_status &&
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {city[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="city"
                                        control={control}
                                        rules={{

                                            minLength: {
                                                value: 2,
                                                message: "City must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "City cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "City contains invalid characters"
                                            }
                                        }}
                                        defaultValue={editData?.city}
                                        render={({ field }) => (
                                            <InputTextElement id="city" {...field} />
                                        )}
                                    />
                                    {errors?.city && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.city.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "State/County" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {state[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="state"
                                        control={control}
                                        rules={{

                                            minLength: {
                                                value: 2,
                                                message: "State Name must be at least 2 characters"
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "State Name cannot exceed 500 characters"
                                            },
                                            pattern: {
                                                value: /^[ A-Za-z0-9()[\].,':\\/#&-]*$/,
                                                message: "State Name contains invalid characters"
                                            }
                                        }}
                                        defaultValue={editData?.state}
                                        render={({ field }) => (
                                            <InputTextElement id="state" {...field} />
                                        )}
                                    />
                                    {errors?.state && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.state.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Postcode" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {postcode[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="postcode"
                                        control={control}
                                        rules={{
                                            pattern: {
                                                value: /^([A-Z0-9]{3,10}([ -]?[A-Z0-9]{1,10})*)$/,
                                                message: "The postcode does not match the required pattern"
                                            }
                                        }}
                                        defaultValue={editData?.postcode}
                                        render={({ field }) => (
                                            <InputTextElement id="postcode" {...field} />
                                        )}
                                    />
                                    {errors?.postcode && (
                                        <small className="text-red-500 ml-1 color_red_new">
                                            {errors?.postcode.message}
                                        </small>
                                    )}
                                </div>
                            </div>
                        }
                        {
                            _.find(props.commonFields, { field_name: "Country" })?.field_status &&
                            <div className="form-group row align-items-center mb-0 mt-0">
                                <div className="col-md-4 pl-0">
                                    <label className="form-label text-left">
                                        {country[0]?.display_name}:
                                    </label>
                                </div>
                                <div className="col pr-0">
                                    <Controller
                                        name="country"
                                        control={control}
                                        defaultValue={countries.find((item) => item.label === editData?.country)}
                                        render={({ field }) => (
                                            <SingleSelectElement
                                                id="country"
                                                {...field}
                                                name="country"
                                                options={(countries != undefined && countries.length > 0) ? countries : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                maxSelectedLabels={1}
                                                onChangeValue={(e) => field.onChange(e.value)}
                                                className="w-full"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </Dialog>
        </div>
    );
}
